module.exports = __webpack_public_path__ + "media/images/icons/mena-arrow-eda00b06fafe29f87b1ffe0bc5384186.svg";